import React, { useState } from 'react';
import { Heart, Sparkles, Coffee, CalendarCheck, CheckCircle2, Users, School, Check } from 'lucide-react';

const StudentFeedbackUI = ({
  studentName = "Sayın Katılımcı",
  riskLevel = "medium",
  onReturnHome,
  studentNo,
  testId,
  studentFeedback = null
}) => {
  const [acknowledged, setAcknowledged] = useState(false);

  // PAYDAŞ TESPİTİ
  const isTeacher = studentNo?.toString().includes("Ogrt-") || testId?.includes("ogretmen");
  const isParent = studentNo?.toString().includes("Veli") || testId?.includes("veli");

  const getFeedbackContent = () => {
    // 1. ÖĞRETMEN İÇİN İÇERİK
    if (isTeacher) {
      return {
        icon: <School className="h-10 w-10 text-emerald-500" />,
        bgColor: "bg-emerald-50 border-emerald-100",
        titleColor: "text-emerald-800",
        title: "Değerli Meslektaşımız,",
        message: "Eğitim-öğretim sürecinin mutfağında, öğrencilerimizi en yakından tanıyan sizlerin gözlemleri bizim için paha biçilemez. Paylaştığınız veriler, okul iklimini iyileştirmek adına stratejik bir öneme sahiptir.",
        subMessage: "Öğrencilerimizin ihtiyaçlarına nokta atışı müdahaleler planlamak için sunduğunuz bu profesyonel iş birliği için teşekkür ederiz.",
        btnStyle: "bg-emerald-600 hover:bg-emerald-700 text-white",
        btnText: "İş Birliği İçin Teşekkürler"
      };
    }

    // 2. VELİ İÇİN İÇERİK
    if (isParent) {
      return {
        icon: <Users className="h-10 w-10 text-blue-500" />,
        bgColor: "bg-blue-50 border-blue-100",
        titleColor: "text-blue-800",
        title: "Değerli Velimiz,",
        message: "Çocuğunuzun eğitim yolculuğunda ve sağlıklı gelişim sürecinde sunduğunuz bu değerli veriler, rehberlik servisimizin gelecek yılki çalışma programını şekillendirmede en büyük yol göstericimiz olacaktır.",
        subMessage: "Okul-aile iş birliğinin gücüne inanıyor, evlatlarımızın geleceği için yanımızda olduğunuzu bilmekten mutluluk duyuyoruz.",
        btnStyle: "bg-blue-600 hover:bg-blue-700 text-white",
        btnText: "Katılımınız İçin Teşekkürler"
      };
    }




       // 🌟 YENİ: KİŞİSEL ENVANTER SONUCU VARSA ÖNCE ONU GÖSTER
    // Holland, Çoklu Zeka, Mesleki Değerler, VAK vb. testlerde kullanılacak.
    // studentFeedback gönderilmezse eski risk motoru aynen çalışmaya devam eder.
    if (studentFeedback) {
      return {
        icon: <Sparkles className="h-10 w-10 text-violet-500" />,
        bgColor: "bg-violet-50 border-violet-100",
        titleColor: "text-violet-900",
        title: studentFeedback.title || "Sonucunda Öne Çıkanlar",
        message:
          studentFeedback.message ||
          "Verdiğin cevaplar, kendinle ilgili bazı özelliklerini daha yakından tanımana yardımcı olabilir.",
        subMessage:
          studentFeedback.counselorNote ||
          "Bu sonucu psikolojik danışmanınla birlikte değerlendirdiğinde kendin hakkında daha fazla şey keşfedebilirsin.",
        btnStyle: "bg-violet-600 hover:bg-violet-700 text-white",
        btnText: studentFeedback.btnText || "Sonucumu Gördüm"
      };
    }

    // 3. ÖĞRENCİ İÇİN RİSK MOTORU (ESKİ MANTIK KORUNDU)
    switch (riskLevel) {
      case 'low':
        return {
          icon: <Sparkles className="h-10 w-10 text-emerald-500" />,
          bgColor: "bg-emerald-50 border-emerald-100",
          titleColor: "text-emerald-800",
          title: "Harika Gidiyorsun!",
          message: "Verdiğin cevaplara baktığımızda okul ve yaşam dengeni genel olarak güzel kurduğunu, karşılaştığın zorluklarla başa çıkma gücünün yüksek olduğunu görüyoruz.",
          subMessage: "Yine de sadece sohbet etmek veya gelecekle ilgili fikir alışverişi yapmak istersen kapımız sana her zaman açık.",
          btnStyle: "bg-emerald-600 hover:bg-emerald-700 text-white",
          btnText: "Bunu Anladım, Teşekkürler!"
        };
      case 'high':
        return {
          icon: <Heart className="h-10 w-10 text-indigo-500" />,
          bgColor: "bg-indigo-50 border-indigo-100",
          titleColor: "text-indigo-800",
          title: "Yalnız Değilsin.",
          message: "Son zamanlarda bazı konuların üst üste geldiğini ve omuzlarındaki yükün biraz ağırlaştığını fark ettik. Bazen hayat yorucu olabilir ve böyle hissetmen çok normal.",
          subMessage: "Bu yükü tek başına taşımak zorunda değilsin. Birlikte bir çıkış yolu bulabiliriz. Müsait olduğun ilk teneffüste PDR Servisine bekliyoruz.",
          btnStyle: "bg-indigo-600 hover:bg-indigo-700 text-white",
          btnText: "Rehberlik Servisini Ziyaret Edeceğim"
        };
      default:
        return {
          icon: <Coffee className="h-10 w-10 text-blue-500" />,
          bgColor: "bg-blue-50 border-blue-100",
          titleColor: "text-blue-800",
          title: "Farkındalığın İçin Teşekkürler",
          message: "Hayatında bazı şeylerin yolunda gittiğini, bazı konularda ise zaman zaman zorlandığını veya kafanın karıştığını anlıyoruz.",
          subMessage: "Zihnini kurcalayan konuları netleştirmek veya sadece dinlenmek için bize uğrayabilirsin. Konuşmak iyi gelir.",
          btnStyle: "bg-blue-600 hover:bg-blue-700 text-white",
          btnText: "Teşekkürler, Uğrayacağım"
        };
    }
  };

  const content = getFeedbackContent();

  const handleAcknowledge = () => {
    setAcknowledged(true);
    setTimeout(() => {
      if (onReturnHome) onReturnHome();
    }, 2000);
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] p-4 md:p-6 font-sans animate-in fade-in duration-700">
      <div className={`max-w-md w-full p-8 rounded-[2.5rem] border text-center shadow-2xl transition-all duration-500 ${content.bgColor}`}>
        <div className="flex justify-center mb-6">
          <div className="bg-white p-4 rounded-2xl shadow-sm border border-white/50">
            {content.icon}
          </div>
        </div>

        <h2 className={`text-2xl font-black mb-4 leading-tight ${content.titleColor}`}>
          {content.title}
        </h2>


        {/* 🌟 KİŞİSEL SONUÇ KARTI */}
        {!isTeacher && !isParent && studentFeedback && (
          <div className="bg-white/80 border border-violet-100 rounded-2xl p-5 mb-6 shadow-sm text-left">
            
            {studentFeedback.eyebrow && (
              <p className="text-[10px] font-black uppercase tracking-[0.18em] text-violet-400 mb-2">
                {studentFeedback.eyebrow}
              </p>
            )}

            {studentFeedback.headline && (
              <h3 className="text-xl font-black text-slate-900 leading-tight">
                {studentFeedback.headline}
              </h3>
            )}

            {Array.isArray(studentFeedback.highlights) &&
              studentFeedback.highlights.length > 0 && (
                <div className="flex flex-wrap gap-2 mt-4">
                  {studentFeedback.highlights.map((item, index) => (
                    <span
                      key={`${item}-${index}`}
                      className="px-3 py-1.5 rounded-full bg-violet-100 text-violet-700 text-xs font-bold border border-violet-200"
                    >
                      {item}
                    </span>
                  ))}
                </div>
            )}

          </div>
        )}
        
        <p className="text-slate-700 text-[15px] leading-relaxed mb-6 font-medium">
          {(!isTeacher && !isParent) && <span className="font-bold text-slate-900">{studentName}, </span>}
          {content.message}
        </p>
        
        <div className="bg-white/60 p-5 rounded-2xl mb-8 border border-white/50 shadow-inner">
          <p className="text-sm text-slate-600 font-semibold italic">
            "{content.subMessage}"
          </p>
        </div>

{/* ✅ KAYIT DURUMU BİLGİSİ */}
{!isTeacher && !isParent && (
  <div className="flex items-center justify-center gap-2 mb-5 text-emerald-700 bg-emerald-50 border border-emerald-100 rounded-xl px-4 py-3">
    <CheckCircle2 className="h-4 w-4 shrink-0" />
    <span className="text-xs font-bold">
      Yanıtların rehberlik servisine başarıyla kaydedildi.
    </span>
  </div>
)}

        {!acknowledged ? (
          <button 
            onClick={handleAcknowledge}
            className={`w-full py-4 rounded-2xl font-bold flex items-center justify-center transition shadow-lg hover:shadow-xl active:scale-95 ${content.btnStyle}`}
          >
            <Check className="h-5 w-5 mr-2" />
            {content.btnText}
          </button>
        ) : (
          <div className="bg-white py-4 px-6 rounded-2xl border border-emerald-200 flex items-center justify-center text-emerald-700 font-bold shadow-inner animate-in zoom-in duration-300">
            <CheckCircle2 className="h-5 w-5 mr-2 text-emerald-500" />
            Tamamlandı. Ana sayfaya dönülüyor...
          </div>
        )}
      </div>
      
      {/* REHBER360 İMZASI */}
      <div className="mt-8 opacity-30 flex items-center gap-2">
        <div className="h-px w-8 bg-slate-400"></div>
        <span className="text-[10px] font-black uppercase tracking-widest text-slate-500">PDR Servisi Dijital Asistanı</span>
        <div className="h-px w-8 bg-slate-400"></div>
      </div>
    </div>
  );
};

export default StudentFeedbackUI;